import Model from 'src/storage/base';

class InviteSignup extends Model {
  id = 'InviteSignup';
  persistent = false;

  apiConfig = {
    checkInvite: {
      url: 'invitation/check-invite',
      validation: {
        code: 'code'
      },
      cancellable: true
    },
    joinInvite: {
      url: 'invitation/join-invite',
      validation: {
        code: 'code',
        username: 'username'
      },
      cancellable: true
    }
  };

  checkInvite = (code, cb) => {
    this.api('checkInvite', { code }, (error, data, success) => {
      cb(error, data, success);
    });
  };

  joinInvite = (code, username, cb) => {
    this.api(
      'joinInvite',
      { code, username, files: [this.state.avatar].filter((i) => !!i) },
      (error, data, success) => {
        cb(error, data, success);
      }
    );
  };
}

const model = new InviteSignup();
export default model;
